module.exports = __webpack_public_path__ + "img/wa_form.1154342a.png";